import React from 'react';
import Deployments from '../../types/Deployments';

export type DeploymentsContextProps = {
    deployments?: Deployments;
    refresh?: Function;
};

export const DeploymentsContext = React.createContext<DeploymentsContextProps>({
    deployments: undefined,
    refresh: undefined,
});
